<div style="margin:10px;">
  <h6 mat-dialog-title>
    {{"Alert" | translate}}
  </h6>

  <div mat-dialog-content style="margin: 10px;" dir="auto" [innerHTML]=[data.message]>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)=[closeDialog()] class="btn border-0"  style="font-size:15px;vertical-align: middle;margin: 10px;" name="closeDialog">
      {{"Ok" | translate}}
    </button>
  </div>
</div>
